import { render, staticRenderFns } from "./AppChecklistsAnswersRead.vue?vue&type=template&id=64d7d5e0&"
import script from "./AppChecklistsAnswersRead.vue?vue&type=script&lang=js&"
export * from "./AppChecklistsAnswersRead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports